import "./breadcrumbHandler.css";

import Hammer from "../../../module/hammer";
import { onTouch } from "../../../hammerUtil";

/**
 * command Handler
 */
class breadcrumbHandler {
  /**
   * @param {object} body
   * @param {Canvas} canvas
   */
  constructor(body, canvas) {
    this.body = body;
    this.canvas = canvas;

    this.iconsCreated = false;
    this.breadcrumbHammers = [];
    this.boundFunctions = {};
    this.touchTime = 0;
    this.activated = false;
    this.options = {};
  }

  /**
   *
   * @param {object} options
   */
  setOptions(options) {
    if (options !== undefined) {
      this.options = options;
      this.create();
    }
  }

  /**
   * Creates or refreshes commander and sets key bindings
   */
  create() {
    if (this.options.breadcrumbButtons === true) {
      if (this.iconsCreated === false) {
        this.loadCommandElements();
      }
    } else if (this.iconsCreated === true) {
      this.cleanCommand();
    }
  }

  /**
   * Cleans up previous command items
   */
  cleanCommand() {
    // clean hammer bindings
    if (this.breadcrumbHammers.length != 0) {
      for (let i = 0; i < this.breadcrumbHammers.length; i++) {
        this.breadcrumbHammers[i].destroy();
      }
      this.breadcrumbHammers = [];
    }

    // clean up previous command items
    if (
      this.commandDOM &&
      this.commandDOM["wrapper"] &&
      this.commandDOM["wrapper"].parentNode
    ) {
      this.commandDOM["wrapper"].parentNode.removeChild(
        this.commandDOM["wrapper"]
      );
    }

    this.iconsCreated = false;
  }

  /**
   * Creation of the command controls nodes. They are drawn over the rest of the nodes and are not affected by scale and translation
   * they have a triggerFunction which is called on click. If the position of the command controls is dependent
   * on this.frame.canvas.clientWidth or this.frame.canvas.clientHeight, we flag horizontalAlignLeft and verticalAlignTop false.
   * This means that the location will be corrected by the _relocateCommand function on a size change of the canvas.
   *
   * @private
   */
  loadCommandElements() {
    this.cleanCommand();

    this.commandDOM = {};
    const commandDivs = ["info"];
    const commandDivActions = ["_info"];
    const commandDivTitle = ["Info"];

    this.commandDOM["wrapper"] = document.createElement("div");
    this.commandDOM["wrapper"].className = "vis-breadcrumb";
    this.canvas.frame.appendChild(this.commandDOM["wrapper"]);

    for (let i = 0; i < commandDivs.length; i++) {
      this.commandDOM[commandDivs[i]] = document.createElement("div");
      this.commandDOM[commandDivs[i]].className =
        "vis-icon vis-" + commandDivs[i];
      this.commandDOM[commandDivs[i]].title = commandDivTitle[i];
      this.commandDOM["wrapper"].appendChild(this.commandDOM[commandDivs[i]]);

      const hammer = new Hammer(this.commandDOM[commandDivs[i]]);
      onTouch(hammer, this[commandDivActions[i]].bind(this));
      this.breadcrumbHammers.push(hammer);
    }

    this.commandDOM["msg"] = document.createElement("div");
    this.commandDOM["msg"].className = "vis-icon vis-crumb";
    this.commandDOM["msg-span"] = document.createElement("span");
    this.commandDOM["msg"].appendChild(this.commandDOM["msg-span"]);
    this.commandDOM["wrapper"].appendChild(this.commandDOM["msg"]);

    this.iconsCreated = true;
  }

  /**
   * this stops all movement induced by the navigation buttons
   *
   * @private
   */
  _info() {
    this.body.emitter.emit("breadcrumb", { action: "info" });
  }
}

export default breadcrumbHandler;
